import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import LoggedComponent from '../../componentsv2/common/LoggedComponent';
import Primary from '../../componentsv2/navigation/Primary';
export const LeftFrame = ({ cacheHit = false, width }) => {
    return (
        <View style={StyleSheet.flatten([Styles.container, { width: width }])}>
            <View style={Styles.wrapper}>
                <LoggedComponent name='PrimaryNav' cacheHit={cacheHit}>
                    <Primary style={{ width: '100%' }} />
                </LoggedComponent>
            </View>
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        borderRightWidth: 0,
        height: '100%',
        justifyContent: 'center'
    },
    text: {
        fontFamily: 'Helvetica',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16,
        textAlign: 'center'
    },
    wrapper: {
        backgroundColor: '#000',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
    }
});
